export const ro = {
  main: {
    color_hex: 'Culoare în notație hexadecimală, începe cu #',
    language: 'Română',
    restricted_field_name: 'Acest nume de câmp este rezervat și nu poate fi utilizat',
    asset_type_required: 'Selectați cel puțin un tip de activ sau faceți câmpul global',
    searchbar: 'Căutare (min. 3 caractere)',
    title: 'Admin',
    logout: 'Logout',
    english: 'Engleză',
    dutch: 'Olandeză',
    french: 'limba franceza',
    spanish: 'Spaniolă',
    danish: 'Danez',
    italian: 'Italiană',
    romanian: 'Română',
    norwegian: 'Norvegiană',
    german: 'Germană',
    drop_image: 'Lasă-ți imaginea aici',
  },
  ra: {
    tree: {
      add_child_node: 'Adăugați o subcategorie',
      add_node_after: 'Adăugați categoria după',
      add_node_before: 'Adăugați o categorie pentru',
      close: 'Închide',
      expand: 'A deschide',
    },
  },
  resources: {
    categories: {
      name: 'Categorie |||| Categorii',
      fields: {
        name: 'Numele categoriei',
      },
    },
    users: {
      name: 'Utilizator |||| Utilizatori',
      fields: {
        category: 'Categorie',
        connection: 'Conexiune',
        email: 'E-mail',
        familyName: 'Nume de familie',
        firstName: 'Nume',
        language: 'Limba',
        userRoles: 'Roluri',
      },
    },
    priorities: {
      name: 'Prioritate |||| Priorități',
    },
    branding: {
      name: 'Siglă',
    },
    invitations: {
      name: 'Invitație |||| Invitații',
      fields: {
        email: 'E-mail',
      },
    },
    'asset-types': {
      name: 'Tip de activ |||| Tipuri de activ',
      fields: {
        name: 'Nume',
      },
    },
    'asset-statuses': {
      name: 'Stare activ |||| Stări activ',
      fields: {
        name: 'Nume',
      },
    },
    'asset-custom-fields': {
      name: 'Câmp personalizat al activului |||| Câmpuri personalizate ale activului',
      fields: {
        name: 'Nume',
        globalField: 'Global (toate tipurile de activ)',
        assetTypeIds: 'Tipuri de activ',
      },
    },
  },
}
